(function() {
  var bar = document.getElementById('cp-announcement-bar');
  var observer = new MutationObserver(function() {
    var wrapper = document.querySelector('.header__search-bar-wrapper');
    if (!wrapper) return;
    var isFixed = wrapper.classList.contains('is-fixed');
    if (bar) bar.style.display = isFixed ? 'none' : '';
    if (isFixed) {
      wrapper.style.setProperty('height', 'auto', 'important');
      wrapper.style.setProperty('bottom', 'auto', 'important');
      var inner = document.querySelector('.search-bar__inner');
      if (inner) inner.style.setProperty('height', 'auto', 'important');
    } else {
      wrapper.style.removeProperty('height');
      wrapper.style.removeProperty('bottom');
      var inner2 = document.querySelector('.search-bar__inner');
      if (inner2) inner2.style.removeProperty('height');
    }
  });
  observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'style'] });
})();